import { Grid } from "@mui/material";
import Portada_Home from "./Componentes/Portada_Home";
import { Helmet } from "react-helmet";
import Problemas_Home from "./Componentes/Problemas_Home";
import Enfoque_Home from "./Componentes/Enfoque_Home";
import Operacion_Home from "./Componentes/Operacion_Home";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import Contacto_Home from "./Componentes/Contacto_Home";
import Problema_Home from "./Componentes/Problema_Home";
import Pasos_Proceso from "./Componentes/Pasos_Proceso";
const Seccion_Home = () => {
    const {sCell} = useResponsive();
    return (
        <>
            <Helmet>
                <title>Mantenimiento Locativo en Cali | Adecuaciones y SST | Espacio Compacto</title>
                <meta
                    name="description"
                    content="Mantenimiento locativo y adecuaciones en Cali para empresas y copropiedades, con cumplimiento SST y sin detener la operación."
                />
                <meta
                    name="keywords"
                    content="mantenimiento locativo Cali, adecuaciones locativas Cali, SST en obras Cali, infraestructura locativa, empresas Cali"
                />

                <meta name="robots" content="index, follow" />
                <link rel="canonical" href="https://espaciocompacto.com/" />

                <meta name="geo.region" content="CO-VAL" />
                <meta name="geo.placename" content="Cali" />
                <meta name="geo.position" content="3.4516;-76.5320" />
                <meta name="ICBM" content="3.4516, -76.5320" />

                <meta property="og:title" content="Mantenimiento Locativo en Cali | Espacio Compacto" />
                <meta property="og:description" content="Adecuaciones locativas y mantenimiento técnico en Cali con cumplimiento SST para empresas." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://espaciocompacto.com/" />
                <meta property="og:image" content="https://espaciocompacto.com/Espaci_Compacto.png" />
                <meta property="og:locale" content="es_CO" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Mantenimiento Locativo en Cali | Espacio Compacto" />
                <meta name="twitter:description" content="Servicios de mantenimiento locativo en Cali para empresas y copropiedades." />
                <meta name="twitter:image" content="https://espaciocompacto.com/Espaci_Compacto.png" />

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "LocalBusiness",
                        "name": "Espacio Compacto",
                        "url": "https://espaciocompacto.com",
                        "telephone": "+57XXXXXXXXXX",
                        "image": "https://espaciocompacto.com/Espaci_Compacto.png",
                        "description": "Mantenimiento locativo y adecuaciones técnicas en Cali con cumplimiento SST.",
                        "areaServed": "Cali",
                        "address": {
                            "@type": "PostalAddress",
                            "streetAddress": "Tu dirección aquí",
                            "addressLocality": "Cali",
                            "addressRegion": "Valle del Cauca",
                            "addressCountry": "CO"
                        },
                        "sameAs": [
                            "https://www.facebook.com/espaciocompacto",
                            "https://www.instagram.com/espaciocompacto"
                        ]
                    })}
                </script>
            </Helmet>
            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{ xs: 12, sm: 12, md: 12 }}
                component="main"
            >
                <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                    <Portada_Home/>
                </Grid>
                <Grid container size={{ xs: 12, sm: 12, md: 12 }} sx={{pt:sCell?8:16}}>
                    <Pasos_Proceso/>
                </Grid>
                {/*<Grid container size={{ xs: 12, sm: 12, md: 12 }} sx={{pt:sCell?8:16}}>*/}
                {/*    <Enfoque_Home/>*/}
                {/*</Grid>*/}
                <Grid container size={{ xs: 12, sm: 12, md: 12 }} sx={{pt:sCell?8:16}}>
                    <Operacion_Home/>
                </Grid>
                <Grid container size={{ xs: 12, sm: 12, md: 12 }} sx={{pt:sCell?8:16}}>
                    <Problemas_Home/>
                </Grid>
                <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                    <Contacto_Home />
                </Grid>
                <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                    <Problema_Home />
                </Grid>
            </Grid>
        </>
    )
}
export default Seccion_Home;
